export const REQUEST_AGGREGATOR = 'requestAggregator';
export const REQUEST_AGGREGATOR_BY_FAMILY_ID = 'requestAggregatorByFamilyId';
export const SET_AGGREGATOR = 'setAggregator';
